import { queryBuilder } from '~/api';

export const deleteCalendarEvent = async (eventId: number): Promise<void> => {
  await queryBuilder('DELETE', `calendar/event/${eventId}`);
  return;
};
